import { useCallback, useState } from 'react';
import type { AxiosInstance } from 'axios';
import { setCasePrioridade, type CaseRecordData } from '@/lib/cases';

/**
 * Alterna a prioridade de um caso e recoloca a lista na ordem do SERVIDOR (E60.F3). // ux-neutrality:allow doc-comment
 *
 * Extraído da `CasosPage` para manter a página sob o limite de linhas do ESLint // ux-neutrality:allow doc-comment
 * — e porque a regra de reordenação merece um lugar com nome. // ux-neutrality:allow doc-comment
 *
 * A ordenação local reproduz a MESMA régua do backend (prioritário primeiro, // ux-neutrality:allow doc-comment
 * chegada como desempate) porque a resposta é de um caso só e recarregar a // ux-neutrality:allow doc-comment
 * lista inteira por um clique seria desproporcional. É duplicação consciente e // ux-neutrality:allow doc-comment
 * localizada: qualquer mudança na régua do servidor precisa vir aqui junto. // ux-neutrality:allow doc-comment
 */
export function ordenarPorPrioridade(casos: CaseRecordData[]): CaseRecordData[] {
  return [...casos].sort(
    (a, b) =>
      Number(b.prioritario === true) - Number(a.prioritario === true) ||
      b.created_at.localeCompare(a.created_at),
  );
}

interface UsePrioridadeCaso {
  emVoo: string | null;
  alternar: (alvo: CaseRecordData) => Promise<void>;
}

export function usePrioridadeCaso(
  client: AxiosInstance,
  aplicar: (atualizar: (atuais: CaseRecordData[] | null) => CaseRecordData[] | null) => void,
  aoFalhar: () => void,
): UsePrioridadeCaso {
  const [emVoo, setEmVoo] = useState<string | null>(null);

  const alternar = useCallback(
    async (alvo: CaseRecordData): Promise<void> => {
      setEmVoo(alvo.id);
      try {
        const atualizado = await setCasePrioridade(client, alvo.id, alvo.prioritario !== true);
        aplicar((atuais) =>
          atuais === null
            ? atuais
            : ordenarPorPrioridade(atuais.map((c) => (c.id === atualizado.id ? atualizado : c))),
        );
      } catch {
        aoFalhar();
      } finally {
        setEmVoo(null);
      }
    },
    [aplicar, aoFalhar, client],
  );

  return { emVoo, alternar };
}
